<button
  class="button__nc"
  [class.fullwidth]="fullWidth"
  [class.link]="link"
  [class.button__white]="color === 'white'"
  [class.button__shimmerGradient]="color === 'shimmer-gradient'"
  [class.stacked]="stacked"
  [class.small]="size === 'small'"
  [class.large]="size === 'large'"
  [disabled]="disabled"
  [routerLink]="routerLink"
  [type]="type"
>
  @if (!!image) {
    <img [class.button__img]="!stacked" src="{{ image }}" />
  }
  {{ label }}
  <ng-content />
</button>
